<template>
    <b-container>
        <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">Electricity Data</div>
      <b-button size="sm" @click="requestDownload()" v-if="admin">
        Export Electricity Data
      </b-button>
      <ag-grid-vue style="width: 100%; height: 500px;"
                     class="ag-theme-balham"
                     :columnDefs="this.electricColumnDefs"
                     :rowData="this.electricRowData"
        >
        </ag-grid-vue>
    </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {FileUtils} from "@/lib/FileUtils";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";

var SizeEnum = {
  SP: 'solarProductivity',
  EM1: 'electricMeter',
  EM2: 'electricMeter2',
  EM3: 'electricMeter3'
};

    export default {
        name: "ElectricMetricTable",
        props: {groupId: String},
        components: {
            AgGridVue
        },

        data() {
            return {
                electricGridOptions: null,
                electricGridApi: null,
                electricColumnApi: null,
                electricColumnDefs: null,
                electricRowData: [],
                bottomData1: [],
                rowStyle1: {fontWeight: 'bold'},
                theGroupId: this.groupId,
                admin: isAdmin()
            }
        },
        beforeMount() {
            this.electricColumnDefs = [
                {
                    headerName: 'Month', field: 'meterUsage'
                },
                {headerName: 'Solar Production(kWh) Winery', field: 'solarProductivity'},
                {headerName: 'Electric Meter 1(kWh) Winery', field: 'electricMeter'},
                {headerName: 'Electric Meter 2(kWh) Tasting/Offices', field: 'electricMeter2'},
                {headerName: 'Electric Meter 3(kWh) Wastewater Ponds', field: 'electricMeter3'}
            ];

            let theGroup = this.theGroupId;
            this.$http.get("metrics/power/graph/" + theGroup)
                .then(resultElectric => {
                    let self = this;
                    self.electricRowData = resultElectric.data;
                }).catch(
                error => {
                    console.log(error)
                });
        },

      methods: {
        requestDownload() {
          let self = this;
          this.$http.get(`metrics/download/${self.theGroupId}/power/wine`, {responseType: "blob"})
              .then(async response => {
                FileUtils.saveExcelToDisk(response);
              });
        },
      }
    }
</script>

<style scoped>

</style>
